import {
  type AIConnector,
  getConnectorDisplayName,
  getConnectorId,
} from "@p0security/shared/types/ai-inventory";

import type { ManagedMcpServer } from "../hooks/useManagedMcpServers.ts";

/** Lowercase + strip non-alphanumerics for substring matching. */
export const normalizeKey = (s: string): string =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "");

export type ServerWithKeys = {
  readonly server: ManagedMcpServer;
  readonly keys: readonly string[];
};

export const indexServers = (
  servers: readonly ManagedMcpServer[]
): ServerWithKeys[] =>
  servers.map((server) => ({
    server,
    keys: [
      normalizeKey(server.id),
      normalizeKey(server.label),
      normalizeKey(server.path),
    ].filter((k) => k.length > 1),
  }));

export const matchConnectorToServer = (
  connector: AIConnector,
  indexed: readonly ServerWithKeys[]
): ManagedMcpServer | undefined => {
  if (indexed.length === 0) return undefined;
  const displayName = normalizeKey(getConnectorDisplayName(connector));
  const connectorId = normalizeKey(getConnectorId(connector));
  for (const { server, keys } of indexed) {
    if (keys.some((k) => displayName.includes(k) || connectorId.includes(k))) {
      return server;
    }
  }
  return undefined;
};

export const serverNodeId = (server: ManagedMcpServer): string =>
  `mcp-server-${server.id}`;
